<template>
  <div>
    <div id="surveyContainer"><survey :survey="survey"></survey></div>
    <div id="error-container" v-if="errors.length > 0">
      <ul>
        <li v-for="(error, i) in errors" v-bind:key="i">{{ error }}</li>
      </ul>
    </div>
    <div id="surveyResult"></div>
  </div>
</template>

<script>
import * as SurveyVue from "survey-vue";
import EventBus from "../event-bus.js";

SurveyVue.StylesManager.applyTheme("default");

import { init as db_product } from "../customWidgets/db_product";
import { init as db_radiogroup } from "../customWidgets/db_radiogroup";

db_product(SurveyVue);
db_radiogroup(SurveyVue);

SurveyVue.Serializer.addProperty("page", {
  name: "progress_group",
  default: "PROGRESS",
  category: "general",
});

export default {
  data() {
    return {
      errors: [],
      errors_tmp: [],
    };
  },
  created() {
    if (this.survey == null) {
      this.setupSurvey();
    }
  },

  computed: {
    survey() {
      return this.$store.state.survey;
    },
  },

  methods: {
    setupSurvey() {
      let self = this;
      let survey;

      let surveyJSON = this.$store.state.surveyJSON;

      survey = new SurveyVue.Model();

      survey.fromJSON(surveyJSON);

      survey.completeText = "Zur Berechnung";

      survey.sendResultOnPageNext = true;

      survey.onComplete.add(function (result) {
        self.$store.commit("setResults", result.data);
        self.$store.commit("setActivePage", "productList");
      });

      survey.onCompleting.add(function (survey, options) {
        self.$store.commit("setResults", survey.data);
        self.$store.commit("setActivePage", "productList");
        options.allowComplete = false;
      });

      survey.onSettingQuestionErrors.add(function (sender, options) {
        options.errors.forEach(function (error) {
          self.errors_tmp.push(error.locText.calculatedText);
          error.locText.text = "";
        });
      });

      survey.onAfterRenderQuestion.add(function (survey, options) {
        survey;
        options;
      });

      survey.onAfterRenderPage.add(function () {
        self.addRowIdentifier();

        document.getElementById("dBConfigurator").scroll(0, 0);
      });

      survey.onValidatePanel.add(function () {
        self.errors = self.errors_tmp;
        self.errors_tmp = [];
      });

      survey.onCurrentPageChanged.add(function (survey, options) {
        survey;
        options;

        if (options.newCurrentPage.name === "Messen") {
          window.hj("vpv", "/messen");
          console.log("hj /messen");
        }
        if (options.newCurrentPage.name === "Stärke") {
          window.hj("vpv", "/staerke");
          console.log("hj /staerke");
        }
        if (options.newCurrentPage.name === "Dämmen") {
          window.hj("vpv", "/daemmen");
          console.log("hj", "/daemmen");
        }
        if (options.newCurrentPage.name === "Verkleiden") {
          window.hj("vpv", "/verkleiden");
          console.log("hj", "/verkleiden");
        }
        if (options.newCurrentPage.name === "Tür") {
          window.hj("vpv", "/tuer");
          console.log("hj", "/tuer");
        }

        self.$store.commit("setPages", self.survey.pages);
        EventBus.$emit("db-current-page-changed");
      });

      survey.onUpdateQuestionCssClasses.add(function (survey, options) {
        var classes = options.cssClasses;

        if (options.question.getType() === "html") {
          classes.root += " sq-root-html";
        }
      });

      this.$store.commit("setSurvey", survey);
    },
    addRowIdentifier() {
      document.getElementsByClassName("sv_row").forEach(function (el) {
        let question = el.getElementsByClassName("sv_qstn")[0];
        el.classList.add("question_row_" + question.getAttribute("name"));
      });
    },
  },
};
</script>

<style>
/*
.sv_main.sv_default_css .sv_p_root > .sv_row {
  background-color: #fff !important;
  margin-bottom: 35px;
}

div.sv_nav:after {
  clear: both;
  content: " ";
  display: table;
}

.question-title {
  width: 812px;
  height: 132px;
  font-family: "Archivo Black", sans-serif;
  font-size: 50px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  color: #000000;
}

.question-title span.green {
  color: #008035;
}

.sv_q.sv_qstn > .sv-vue-row-additional-div.content-left {
  float: right;
}

.sv_q_title {
  font-weight: bold;
  color: #000;

  font-family: "Roboto Slab", serif;
}
.sv_q_description {
  color: #000;
  font-weight: light;
  width: 272px;
  font-family: "Roboto Slab", serif;
}

.sv_q_text_root {
  height: 58px;
  border: solid 1px #cfcfcf;
  text-align: center;
  color: #008035 !important;
  outline-color: #008035;
}

.sv_q_dropdown_control {
  width: 272px;
  height: 58px;
  border: solid 1px #cfcfcf;
  text-align: center;
  color: #008035 !important;
  padding: 20px;
  outline-color: #008035;
}

.sv_main .sv_body .sv_nav input.sv_next_btn {
  width: 199px;
  height: 40px;
  border-radius: 36.5px;
  border-width: 0;
  background-color: #008035;
  float: right;
  outline: none;
}

.sv_main .sv_body .sv_nav input.sv_next_btn:hover {
  background-color: #008c3d;
}

.sv_next_btn:after {
  content: "fdfd" !important;
  width: 30px;
  height: 30px;
  display: block;
}

.sv_prev_btn {
  width: 199px;
  height: 40px;
  border-radius: 36.5px;
  border-width: 0;
  background-color: #f5f3ee !important;
  color: #008035 !important;
  outline: none;
}
.sv_complete_btn {
  width: 199px;
  height: 40px;
  border-radius: 36.5px;
  border-width: 0;
  background-color: #008035 !important;
  float: right;
}

.sv_q_erbox {
  color: #da5555;
}

.sv_p_root,
.sv_body {
  min-height: 625px;
}

.sq-root-html {
  color: #000;
  font-family: "Roboto Slab", serif;
}

#error-container {
  margin-top: 15px;
  padding: 10px;
  border: 1px solid #c91436;
  color: #c91436;
  background-color: #f4d2d8;
  font-family: "Roboto Slab", serif;
}

#error-container ul {
  padding-left: 0;
  list-style: none;
}
*/
</style>
